export default __webpack_public_path__ + "static/media/person.8ec57faa.svg";